import React from "react";

import * as S from "./styles";

export const Slide25: React.FC = () => {
  return (
    <S.Container>
      <S.Title>créditos | gloria groove:</S.Title>
      <S.Text>
        <p>
          Direção criativa: Luciano Schmitz
          <br />
          Foto: Nicole Heiniger
          <br />
          Direção de vídeo: Maurício Kessler
          <br />
          Edição de moda: Flávia Pommianosky e Davi Ramos
          <br />
          Maquiagem: Gloria Groove
          <br />
          Cabelo: Kelly
          <br />
          Direcionamento de beleza: Branca Moura
          <br />
          Assistente de beleza: Mayara Ramos
          <br />
          Produção de moda: Well Santos
          <br />
          Camareira: Jô Alcantara <br />
          Produção de arte e cenografia: Anderson Rodriguez
          <br />
          Contrarregra: Ronaldo Junge
          <br />
          Assistentes de foto: Renato Machado, Bruno Pereira e Fernando Lima
          <br />
          Chefe de elétrica: Sérgio Bronzo
          <br />
          Primeiro assistente de câmera: Cristiano Machado
          <br />
          Operadora de câmera: Dariely Belke
          <br />
          Primeiro assistente de elétrica: Sergio Bronzo Junior
          <br />
          Segundo assistente de elétrica: Rudney Santos
          <br />
          Produção executiva: Isabela de Paula
          <br />
          Produção executiva de vídeo: Chico Soll
          <br />
          Tratamento de imagem: Thiago Auge
          <br />
          Edição: Rob & Ariel
          <br />
          Digital composer: Fernando Branco
        </p>
      </S.Text>
      <S.Title>looks do editorial:</S.Title>
      <S.Text>
        <p>
          Gloria Groove (look 1)
          <br />
          Vestido corselete, Rober Dognani, R$ 2.790. Macacão de renda com
          cinta-liga, Arara Criativa, somente aluguel. Luvas de vinil, Acervo
          Yk, somente aluguel. Escarpim, acervo da artista.
        </p>

        <p>
          Gloria Groove (look 2)
          <br />
          Conjunto de strass, Atelier Robbyt Moon, R$ 1.300. Tapa-olho de
          cristais, Chapéus Davi Ramos, preço sob consulta.
        </p>
      </S.Text>
    </S.Container>
  );
};
